import React from "react";
import {Icon} from '@fluentui/react';


class Warning extends React.Component {
    render() {
        let warningIcon;

        switch (this.props.element) {
            case "withLabel":
              warningIcon =  <div className='warning-inline warning-withlabel'><Icon iconName="Warning" /></div>
              break;
            case "noLabel":
                warningIcon =<div className='warning-inline warning-nolabel'><Icon  iconName="Warning"/></div>
                break;
            case 'withlabel-basepicker':
                warningIcon = <div className='warning-inline warning-withlabel-basepicker'><Icon  iconName="Warning"/></div>
                break;
            case 'nolabel-basepicker':
                warningIcon = <div className='warning-inline warning-nolabel-basepicker'><Icon  iconName="Warning"/></div>
                break;
            default:
                warningIcon = <div className='warning'><Icon  iconName="Warning"/></div>
                break;
        }
        return (
            <div>
                {warningIcon}
            </div>
        );
    }
}
export default Warning



// WEBPACK FOOTER //
// ./src/components/CreateSite/CommonComponents/Warning.js